import React, {Component} from 'react';
import SkillBar from "./skillBar";

export default class Skills extends Component {
    render() {

        const skills = [
            {type: "Programmming", level: 90},
            {type: "Communication", level: 85},
            {type: "Machine Learning & NLP", level: 85},
            {type: "Web Development", level: 85},
            {type: "Research", level: 80},
            {type: "Open Source Usage", level: 80},
            {type: "Teaching", level: 72},
            {type: "Creativity & Flow", level: 70},
            {type: "Philosophy", level: 60},
            {type: "Cloud", level: 30},
        ];

        return (
            <div>
                <SkillBar hue="225" saturation="20" skills={skills}/>
            </div>
        );
    }
}